import { render, staticRenderFns } from "./HelpCenterCategoriesList.vue?vue&type=template&id=d0113da2&"
import script from "./HelpCenterCategoriesList.vue?vue&type=script&lang=js&"
export * from "./HelpCenterCategoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports